<template>
  <div class="container-fluid" v-if="route.meta.imgBanner != null">
    <div>
      <Images :preview="false" :src="route.meta.imgBanner"></Images>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";
import Images from '@/components/image/Images.vue'
const route = useRoute();
</script>
<style lang="css" scoped>
  .container-fluid {
    padding-left: unset;
    padding-right: unset;
  }
</style>